import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { getActiveUsers } from "../../actions/auth";

import RegisterEmployer from "../layout/Employers/RegisterEmployer";
import EmployerLogin from "../layout/Employers/EmployerLogin";

import TwoFARequestEmployer from "../layout/Employers/TwoFARequestEmployer";

const Employers = ({
  auth: { user, channelid, companyname, location, verified },
  message: { users },
  isAuthenticated,
  getActiveUsers,
  redirected,
}) => {
  const [showAuthentication, setShowAuthentication] = useState(true);

  if (isAuthenticated && user.role === "employer") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequestEmployer
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          companyname={companyname}
          location={location}
        />
      )}
      <EmployerLogin />
      <div className="flex-all-content-fixed">
        <div className="main-content">
          <div className="feature-register-container">
            {/* <RegisterEmployer getActiveUsers={getActiveUsers} users={users} /> */}
            <div className="coming-soon blue">COMING SOON</div>
          </div>
          <section className="site-features-alt grey">
            <div className="feature-container">
              <div className="feature-name-container">
                <p className="feature-name blue bold">
                  Modernized Talent Aquisition
                </p>
              </div>
              <img
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/adult-business-communication.jpg"
                }
                className="feature-image-container"
              />
              <div className="feature-description-container">
                <p className="feature-description">
                  Enhance your recruiting skills to new heights and discover the
                  perfect Innovator for the role. With our advanced tools and
                  resources, you'll streamline the recruitment process and
                  attract top talent. Moreover, you'll gain insights into
                  industry trends and best practices, ensuring that your hiring
                  strategies are always ahead of the curve.
                </p>
              </div>
            </div>
            <div className="site-features">
              <div className="feature-container">
                <div className="feature-name-container">
                  <p className="feature-name blue bold">Live Job Stream</p>
                </div>
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/img/video_conference.jpg"
                  }
                  className="feature-image-container"
                />
                <div className="feature-description-container">
                  <p className="feature-description">
                    With ime's Live Job Stream, you'll have the chance to engage
                    in real-time conversations with potential candidates. Dive
                    into the trending topics related to your job post and make
                    significant progress in the qualifying process. It's an
                    innovative way to connect with top talent and streamline
                    your hiring efforts.
                  </p>
                </div>
              </div>
              <div className="site-features">
                <div className="feature-container">
                  <div className="feature-name-container">
                    <p className="feature-name blue bold">VR Tours</p>
                  </div>
                  <img
                    src={
                      "https://ime.sfo3.cdn.digitaloceanspaces.com/img/vr_tour.jpg"
                    }
                    className="feature-image-container"
                  />
                  <div className="feature-description-container">
                    <p className="feature-description">
                      Discover the power of virtual reality technology with VR
                      Tours. These tours enable employers to provide an in-depth
                      look at their workplace, showcasing breathtaking views,
                      impressive workspaces, and more. Get creative with your VR
                      Tour and give potential new hires a glimpse of "a day in
                      the life" as an employee at your company. It's a fantastic
                      way to attract top talent and highlight the unique aspects
                      of your work environment.
                    </p>
                  </div>
                </div>
              </div>
              <div className="site-features">
                <div className="feature-container">
                  <div className="feature-name-container">
                    <p className="feature-name blue bold">Employer Spotlight</p>
                  </div>
                  <img
                    src={
                      "https://ime.sfo3.cdn.digitaloceanspaces.com/img/employer_of_week.jpg"
                    }
                    className="feature-image-container"
                  />
                  <div className="feature-description-container">
                    <p className="feature-description">
                      There are many innovative and highly regarded employers
                      who truly deserve recognition. With ime's Employer
                      Spotlight, we aim to shine a spotlight on these companies,
                      regardless of their size. Allow us to showcase the
                      incredible culture your company possesses, as well as any
                      accolades and achievements you'd like to share with the
                      world. Let's celebrate your success together!
                    </p>
                  </div>
                </div>
              </div>
              <div className="site-features">
                <div className="feature-container">
                  <div className="feature-name-container">
                    <p className="feature-name blue bold">Approved Mentors</p>
                  </div>
                  <img
                    src={
                      "https://ime.sfo3.cdn.digitaloceanspaces.com/img/handshake.jpg"
                    }
                    className="feature-image-container"
                  />
                  <div className="feature-description-container">
                    <p className="feature-description">
                      With "Approved Mentors", employers can endorse the
                      creative and innovative content produced by ime's Mentors.
                      Discover the Mentor(s) whose content aligns perfectly with
                      your target audience. Endorsing Mentors can enhance your
                      brand's credibility and connect with a wider community of
                      like-minded individuals.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  message: state.message,
  isAuthenticated: state.auth.isAuthenticated,
  redirected: state.auth.redirected,
});

export default connect(mapStateToProps, { getActiveUsers })(Employers);
